var _path, _path2, _rect, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLockFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 8h24l10 10v38H16z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40 8v12h12"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 34,
    width: 24,
    height: 16,
    rx: 3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29 34v-5a7 7 0 0 1 14 0v5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockFile);
export default __webpack_public_path__ + "static/media/lock-file.7fcf2dfaf191dae6e3bc9b044aad079c.svg";
export { ForwardRef as ReactComponent };